import { useState } from "react"

export interface StarRatingProps {
  value: number
  onChange?: (value: number) => void
  size?: number
  label?: string
}

/** Accessible 1–5 star control with a read-only mode. */
export function StarRating({ value, onChange, size = 18, label = "Rating" }: StarRatingProps) {
  const [hover, setHover] = useState<number | undefined>(undefined)
  const shown = hover ?? value

  return (
    <div className="star-rating" role={onChange ? "radiogroup" : "img"} aria-label={`${label}: ${value} of 5`}>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          className={`star ${star <= shown ? "star-filled" : ""}`}
          aria-label={`${star} star${star === 1 ? "" : "s"}`}
          role={onChange ? "radio" : undefined}
          aria-checked={onChange ? Math.round(value) === star : undefined}
          aria-pressed={onChange ? undefined : star <= value}
          disabled={!onChange}
          onMouseEnter={() => onChange && setHover(star)}
          onMouseLeave={() => onChange && setHover(undefined)}
          onFocus={() => onChange && setHover(star)}
          onBlur={() => onChange && setHover(undefined)}
          onClick={() => onChange?.(star)}
        >
          <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
            <path
              d="m12 3.5 2.7 5.6 6.1.9-4.4 4.3 1 6.1-5.4-2.9-5.4 2.9 1-6.1L3.2 10l6.1-.9L12 3.5Z"
              fill={star <= shown ? "currentColor" : "none"}
              stroke="currentColor"
              strokeWidth={1.5}
              strokeLinejoin="round"
            />
          </svg>
        </button>
      ))}
    </div>
  )
}
